import { render, staticRenderFns } from "./ReadOnly.vue?vue&type=template&id=18f459ad&scoped=true&"
import script from "./ReadOnly.vue?vue&type=script&lang=js&"
export * from "./ReadOnly.vue?vue&type=script&lang=js&"
import style0 from "./ReadOnly.vue?vue&type=style&index=0&id=18f459ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f459ad",
  null
  
)

export default component.exports